<template>
  <Dialog
    :visible="visible"
    :title="$t(`${namespace}.title`)"
    @close="close('icon')"
  >
    <div>
      <v-card-text class="dialog__body">
        <p>{{ $t(`${namespace}.text`) }}</p>

        <v-checkbox
          v-model="showWizard"
          :label="$t(`${namespace}.checkbox`)"
          color="primary"
          on-icon="check_box"
          off-icon="check_box_outline_blank"
        />
      </v-card-text>

      <v-divider />

      <v-card-actions class="dialog__footer">
        <v-spacer />

        <a
          class="mr-4"
           @click.prevent="close('cancel')"
        >
          {{ $t('Common.cancel') }}
        </a>

        <Button @click="skipTutorial">
          {{ $t(`${namespace}.confirm`) }}
        </Button>
      </v-card-actions>
    </div>
  </Dialog>
</template>

<script>
import { SESSION_SKIP_WIZARD } from 'utils/constants'

export default {
  name: 'SkipTutorialDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      namespace: 'Views.WizardPage.skipTutorialDialog',
      showWizard: false
    }
  },
  methods: {
    close (type) {
      if (type === 'icon') this.$ga.event('botao', 'clicou', 'fechar_pular')
      if (type === 'cancel') this.$ga.event('botao', 'clicou', 'cancelar_pular')
      this.$emit('close')
    },

    skipTutorial () {
      this.$ga.event('botao', 'clicou', 'prosseguir_tutorial')
      this.$router.push({ name: 'Dashboard' })
    }
  },
  watch: {
    showWizard (boolean) {
      boolean
        ? localStorage.setItem(SESSION_SKIP_WIZARD, true)
        : localStorage.removeItem(SESSION_SKIP_WIZARD)
    }
  }
}
</script>
